/* eslint-disable complexity */
/* eslint-disable max-lines-per-function */
import React from 'react';
import { ENABLE_FULL_RESPONSIVE } from 'reactApp/appHelpers/configHelpers';
import { BREAKPOINT_MD, BREAKPOINT_SM } from 'reactApp/constants/breakpoints';
import { FeatureSelector } from 'reactApp/modules/features/components/FeatureSelector';
import { getFeatureNewContentGrid } from 'reactApp/modules/features/features.selectors';
import { useWindowWidth } from 'reactApp/ui/VirtualList/VirtualList.hooks';

import styles from '../../DataListItemRow.css';
import newStyles from '../../DataListItemRow.new.css';
import { HomeItemProps } from '../../DataListItemRow.types';
import { Checkbox } from '../Checkbox';
import { Date } from '../Date';
import { Download } from '../Download';
import { Expires } from '../Expires';
import { Favorite } from '../Favorite';
import { ItemName } from '../ItemName';
import { ItemTip } from '../ItemTip/ItemTip';
import { Pic } from '../Pic';
import { Progress } from '../Progress';
import { Publish } from '../Publish';
import { Home } from '../RowFor/Home';
import { Size } from '../Size';

const HomeItem = (props: HomeItemProps) => {
    const {
        denyDoAction,
        onCheckboxClick,
        isSelected,
        tipData,
        thumbUrl,
        isFolder,
        kind,
        isVirus,
        ext,
        author,
        name,
        favoritesAvailable,
        isInFavorites,
        onFavorites,
        publicExpires,
        mtime,
        isAutoDelete,
        onDownload,
        progress,
        onCancelUpload,
        onPublish,
        isPublic,
        size,
        id,
        storage,
    } = props;
    const windowWidth = useWindowWidth();
    const isProgress = denyDoAction;

    return (
        <FeatureSelector
            selector={getFeatureNewContentGrid}
            variant1={<Home {...props} checkboxClassname={newStyles.check} favoriteClassname={newStyles.favoriteAction} />}
            control={
                <>
                    <Checkbox onCheckboxClick={onCheckboxClick} isSelected={isSelected} isDisabled={denyDoAction} />
                    <Pic
                        isFolder={isFolder}
                        thumbUrl={thumbUrl}
                        kind={kind}
                        isVirus={!!isVirus}
                        ext={ext || ''}
                        author={author}
                        isAutoDelete={isAutoDelete}
                    />
                    {!ENABLE_FULL_RESPONSIVE ? (
                        <>
                            <ItemTip tipData={tipData} isFolder={isFolder ?? false} />
                            <ItemName name={name} ext={ext || ''} loading={isProgress} id={id} isRenameAvailable={props.renameAvailable} />
                            {!isProgress && (
                                <Favorite isAvailable={!!favoritesAvailable} isActive={!!isInFavorites} onClick={onFavorites} />
                            )}
                            {isFolder ? <Expires expires={publicExpires} isAutoDelete={isAutoDelete} /> : <Date date={mtime} isWide />}
                            <Size size={size} />
                            <Download
                                onClick={onDownload}
                                ext={isFolder ? 'zip' : ext}
                                size={size}
                                id={id}
                                storage={storage}
                                show={!isProgress}
                            />
                            {isProgress ? (
                                <Progress className={styles.progress} progress={progress} onClick={onCancelUpload} />
                            ) : (
                                <Publish onClick={onPublish} isActive={isPublic} />
                            )}
                        </>
                    ) : (
                        <>
                            {windowWidth > BREAKPOINT_SM ? (
                                <>
                                    <ItemTip tipData={tipData} isFolder={isFolder ?? false} />
                                    <ItemName
                                        name={name}
                                        ext={ext || ''}
                                        loading={isProgress}
                                        id={id}
                                        isRenameAvailable={props.renameAvailable}
                                    />
                                </>
                            ) : (
                                <div className={styles.responsiveNameWrapper}>
                                    <ItemTip tipData={tipData} isFolder={isFolder ?? false} />
                                    <ItemName name={name} ext={ext || ''} loading={isProgress} id={id} />

                                    <span className={styles.responsiveDateWrapper}>
                                        <Size size={size} />
                                        {!!mtime && <>&nbsp;•&nbsp;</>}
                                        <Date date={mtime} isWide />
                                    </span>
                                    <Expires expires={publicExpires} isAutoDelete={isAutoDelete} isShared={!!publicExpires} />
                                </div>
                            )}
                            {!isProgress && windowWidth > BREAKPOINT_MD && (
                                <Favorite isAvailable={!!favoritesAvailable} isActive={!!isInFavorites} onClick={onFavorites} />
                            )}
                            {windowWidth > BREAKPOINT_SM && (
                                <>
                                    {mtime && <Date date={mtime} isWide />}
                                    <Expires expires={publicExpires} isAutoDelete={isAutoDelete} isShared={!!publicExpires} />
                                    <Size size={size} />
                                </>
                            )}
                            <div className={styles.actionsWrapper}>
                                {!isProgress && windowWidth <= BREAKPOINT_MD && (
                                    <Favorite isAvailable={!!favoritesAvailable} isActive={!!isInFavorites} onClick={onFavorites} />
                                )}
                                <Download
                                    onClick={onDownload}
                                    ext={isFolder ? 'zip' : ext}
                                    size={size}
                                    id={id}
                                    storage={storage}
                                    show={!isProgress}
                                />
                                {isProgress ? (
                                    <Progress className={styles.progress} progress={progress} onClick={onCancelUpload} />
                                ) : (
                                    <Publish onClick={onPublish} isActive={isPublic} />
                                )}
                            </div>
                        </>
                    )}
                </>
            }
        />
    );
};

export default HomeItem;
